module.exports = __webpack_public_path__ + "static/media/warning.5dbe54c2.png";